<template>
    <div class="section">
        <Login />
        <div  v-if="user && !user.isAnonymous"  class="container">
            <h1 class="title is-2">Generate Sitemap</h1>
            
            
            
             <div class="generalcontainer">
                <div class="generalcontainer centered">
                    <div class="standardtext">
                        Create a sitemap algorithm
                    </div>
                    <div class="smalltext">
                        Once you created it, include it in the server to be served to crawlers
                    </div>
                </div>

                <div class="generalcontainer">
                    <div class="button button-tag-mid inverted-green" @click="getStyles()">Get all styles</div>
                    {{styles.length}}
                </div>
                <div class="generalcontainer">
                    <div class="button button-tag-mid inverted-green" @click="getContinents()">Get all Continents</div>
                    {{continents.length}}
                </div>
                <div class="generalcontainer">
                    <div class="button button-tag-mid inverted-green" @click="getRoutes()">Get all Routes</div>
                    {{routes.length}}
                </div>
                <div class="generalcontainer">
                    <div class="button button-tag-mid inverted-green" @click="getCountries()">Get all Countries</div>
                    {{countries.length}}
                </div>
                <div class="generalcontainer">
                    <div class="button button-tag-mid inverted-green" @click="getStates()">Get all States</div>
                    {{states.length}}
                </div>
                <div class="generalcontainer">
                    <div class="button button-tag-mid inverted-green" @click="getRidertags()">Get all Rider Tags</div>
                    {{ridertags.length}}
                </div>
                <div class="generalcontainer">
                    <div class="button button-tag-mid inverted-green" @click="getSites()">Get all Sites</div>
                    {{sites.length}}
                </div>
                

                <div class="generalcontainer">
                    <div class="button button-tag-mid inverted-green" @click="createSitemap()">Create sitemap</div>
                </div>
            </div>
           

         

        </div>

        
     
    </div>  
</template>

<script>
// import {allcountries} from "../data.js";
import Login from '@/components/Login';
export default {
    name: 'SitemapAdmin',
    components: {Login},
    data () {
        return {
            styles: [],
            routes: [],
            countries: [],
            states: [],
            ridertags: [],
            sites: [],
            continents: [],
            features: ['desert', 'couples', 'adventurecycling']
        }
    
    },
    computed: {
     user: function() {
            return this.$getParent('App').user;
        }
    },
    methods: {
        keyify(str) {
            return encodeURI(str.toLowerCase());
        },
     
        //======= METHOD TO CREATE A SITEMAP FOR DYNAMIC CONTENT ==============
        createSitemap() {
            var doc = document.implementation.createDocument('', '', null);
            //create the outer tag
            var urlset = doc.createElement("urlset");
            urlset.setAttribute("xmlns", "http://www.sitemaps.org/schemas/sitemap/0.9");
            var url = ''; var changefreq = ''; var loc = '';
                        
            //first create static sites (examples)
            var staticSites = ['', 'about', 'share', 'styles', 'routes', 'countries', 'ridertags', 'sites', 'books'];
            for (var i=0; i < staticSites.length; i++) {
                url = doc.createElement("url");
                loc = doc.createElement('loc');
                loc.innerHTML = 'https://bikesleepbike.com/' + staticSites[i];
                changefreq = doc.createElement("changefreq");
                changefreq.innerHTML = 'monthly';
                url.appendChild(loc);
                url.appendChild(changefreq);
                urlset.appendChild(url);
            }            
            //append styles urls
            for (var i=0; i < this.styles.length; i++) {
                url = doc.createElement("url");
                loc = doc.createElement('loc');
                loc.innerHTML = 'https://bikesleepbike.com/styles/' + this.styles[i];
                changefreq = doc.createElement("changefreq");
                changefreq.innerHTML = 'weekly';
                url.appendChild(loc);
                url.appendChild(changefreq);
                urlset.appendChild(url);
            }     
            for (var i=0; i < this.continents.length; i++) {
                url = doc.createElement("url");
                loc = doc.createElement('loc');
                loc.innerHTML = 'https://bikesleepbike.com/continents/' + encodeURI(this.continents[i]);
                changefreq = doc.createElement("changefreq");
                changefreq.innerHTML = 'weekly';
                url.appendChild(loc);
                url.appendChild(changefreq);
                urlset.appendChild(url);
            }     
            for (var i=0; i < this.routes.length; i++) {
                console.log(encodeURIComponent(this.routes[i]));
                url = doc.createElement("url");
                loc = doc.createElement('loc');
                loc.innerHTML = 'https://bikesleepbike.com/routes/' + encodeURIComponent(this.routes[i]);
                changefreq = doc.createElement("changefreq");
                changefreq.innerHTML = 'weekly';
                url.appendChild(loc);
                url.appendChild(changefreq);
                urlset.appendChild(url);
            }   
            for (var i=0; i < this.countries.length; i++) {
                console.log(encodeURIComponent(this.countries[i]));
                url = doc.createElement("url");
                loc = doc.createElement('loc');
                loc.innerHTML = 'https://bikesleepbike.com/countries/' + encodeURIComponent(this.countries[i]);
                changefreq = doc.createElement("changefreq");
                changefreq.innerHTML = 'weekly';
                url.appendChild(loc);
                url.appendChild(changefreq);
                urlset.appendChild(url);
            }   
            for (var i=0; i < this.states.length; i++) {
                console.log(encodeURIComponent(this.states[i]));
                url = doc.createElement("url");
                loc = doc.createElement('loc');
                loc.innerHTML = 'https://bikesleepbike.com/countries/' + encodeURIComponent('United States') + '/' + encodeURIComponent(this.states[i]);
                changefreq = doc.createElement("changefreq");
                changefreq.innerHTML = 'weekly';
                url.appendChild(loc);
                url.appendChild(changefreq);
                urlset.appendChild(url);
            }   
            for (var i=0; i < this.ridertags.length; i++) {
                console.log(encodeURIComponent(this.ridertags[i]));
                url = doc.createElement("url");
                loc = doc.createElement('loc');
                loc.innerHTML = 'https://bikesleepbike.com/ridertags/' + encodeURIComponent(this.ridertags[i]);
                changefreq = doc.createElement("changefreq");
                changefreq.innerHTML = 'weekly';
                url.appendChild(loc);
                url.appendChild(changefreq);
                urlset.appendChild(url);
            }   
            for (var i=0; i < this.sites.length; i++) {
                console.log(encodeURIComponent(this.sites[i]));
                url = doc.createElement("url");
                loc = doc.createElement('loc');
                loc.innerHTML = 'https://bikesleepbike.com/sites/' + encodeURIComponent(this.sites[i]);
                changefreq = doc.createElement("changefreq");
                changefreq.innerHTML = 'weekly';
                url.appendChild(loc);
                url.appendChild(changefreq);
                urlset.appendChild(url);
            }   
            for (var i=0; i < this.features.length; i++) {
                console.log(encodeURIComponent(this.features[i]));
                url = doc.createElement("url");
                loc = doc.createElement('loc');
                loc.innerHTML = 'https://bikesleepbike.com/feature/' + encodeURIComponent(this.features[i]);
                changefreq = doc.createElement("changefreq");
                changefreq.innerHTML = 'weekly';
                url.appendChild(loc);
                url.appendChild(changefreq);
                urlset.appendChild(url);
            }   
           
            
            doc.appendChild(urlset);
            //serialize the xml file to txt
            var oSerializer = new XMLSerializer();
            var xmltext = oSerializer.serializeToString(doc);
            xmltext = '<?xml version="1.0" encoding="UTF-8"?>' + xmltext;
            //download the txt
            var pom = document.createElement('a');
            var filename = "sitemap.xml";
            var pom = document.createElement('a');
            var bb = new Blob([xmltext], {type: 'text/plain'});
            pom.setAttribute('href', window.URL.createObjectURL(bb));
            pom.setAttribute('download', filename);
            pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
            pom.draggable = true; 
            pom.classList.add('dragout');
            pom.click();
         
            
        },
        
           //======== METHODS FOR DYNAMIC CONTENT ========
        getStyles() {
          this.styles = ['touring', 'bikepacking','racing','short','road','gravel', 'singletrack','bikepath','mountains','desert','ocean','cities'];
        },
        getContinents() {
          this.continents = ['North America','South America','Europe','Asia','Africa','Oceania'];
        },

        getRoutes() {
            var that = this;
            this.$db.collection('routes').get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (doc.data().display_name) {
                        that.routes.push(doc.data().display_name);
                    }  else {
                        console.log("ERROR: Can't fetch routes");
                    }
                })
                .catch(function(error) {
                    console.log("Error getting links by type: ", error);
                    that.isLoading = false;
                });
                    
                    // }
                });
            
            console.log(this.routes);
        },

        getCountries() {
            var that = this;
            this.$db.collection("page_counts").doc('countries').get()
                .then(function(doc) {
                    if (doc.exists) {
                        for (const countrycode in doc.data()) {
                            that.countries.push(that.$countrymap[countrycode]);
                        }
                    } 
                });
        },
        
        getStates() {
            var that = this;
            this.$db.collection("regions").doc("US").get()
                .then(function(doc) {
                    if (doc.exists) {
                        var regions = doc.data().regions;
                    
                        that.states = regions.sort();
                        that.states.push('all'); //for states page
                    }
                });
            
        },

        getRidertags() {
            var that = this;
            this.$db.collection("page_counts").doc('ridertags').get()
                .then(function(doc) {
                    if (doc.exists) {
                        for (const tag in doc.data()) {
                            that.ridertags.push(tag);
                        }
                    } 
                });
        },

        getSites() {
            var that = this;
            this.$db.collection("page_counts").doc('sites').get()
                .then(function(doc) {
                    if (doc.exists) {
                        for (const site in doc.data()) {
                            that.sites.push(site);
                        }
                    } 
                });
        },

       
       
 


        adminFunctionBroken() {
            // replace route data with keys
            var that = this;
            this.$db.collection("pages").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    var pageData = doc.data();
                    var pageId = doc.id;
                    var routes = pageData.routes;
                    var routes_new = [];
                    if (routes && routes.length > 0) {
                        console.log("setting doc with id " + pageId + " to have routes_old field ");
                        console.log(routes);
                        // that.$db.collection("pages").doc(pageId).set({routes_old: routes},  { merge: true });

                        routes.forEach(function(oldroute) {
                            that.$db.collection('routes').where("display_name", "==", oldroute).get().then(function(querySnapshot) {
                                querySnapshot.forEach(function(innerdoc) {
                                    console.log(innerdoc.data());
                                    var innerID = innerdoc.id;
                                    var innerData = innerdoc.data();
                                    console.log(innerID);
                                    if (innerID) {
                                        routes_new.push(innerID);
                                    }
                                });
                            });

                        });

                    }
                    console.log(routes_new);
                });
            });
            // this.$db.collection('routes')

        },
        adminFunctionRoutes() {
            var that = this;
            var uniqueSites = [];
            var uniqueCountries = {};
            var uniqueRoutes = {};
            var uniqueContinents = {};
            var pageCount = 0;
            // console.log("fetching totals");
            this.$db.collection('pages').get().then(function(querySnapshot) {
                console.log("fetched");
                pageCount = querySnapshot.size;
                console.log("Page count: " + pageCount);
                querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                    var pageData = doc.data();
                    pageData.routes.forEach(function(routeDisplayName) {

                        var routeKey = that.keyify(routeDisplayName);

                        if (routeKey in uniqueRoutes) {
                            var dataObj = uniqueRoutes[routeKey];
                            dataObj.post_count = dataObj.post_count + 1;
                        } else {
                            uniqueRoutes[routeKey] = {post_count: 1, display_name: routeDisplayName};
                        }
                    });
             
                });

                console.log("routes list: ");
                console.log(uniqueRoutes);

                if (Object.keys(uniqueRoutes).length > 0) {
                    console.log("yup");
                    // this.$db.collection('counts').doc('totals').set({_continents:uniqueContinents.length},  { merge: true });
                    for (const keyified in uniqueRoutes) {
                        var data = {};
                        // var id = keyify(pageData.continent);
                        data.display_name = uniqueRoutes[keyified].display_name;
                        data.post_count = uniqueRoutes[keyified].post_count;
                        data.type = "route";
                        data.url_path = keyified;
                        console.log(data);
                        that.$db.collection('routes').doc(keyified).set(data,  { merge: true });
                    }
                    // return pageCount;
                }
            });
        },
        adminFunctionContinents() {
            var that = this;
            var uniqueSites = [];
            var uniqueCountries = {};
            var uniqueRoutes = [];
            var uniqueContinents = {};
            var pageCount = 0;
            // console.log("fetching totals");
            this.$db.collection('pages').get().then(function(querySnapshot) {
                console.log("fetched");
                pageCount = querySnapshot.size;
                console.log("Page count: " + pageCount);
                querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                    var pageData = doc.data();

                    var continentKey = that.keyify(pageData.continent);
                    if (continentKey in uniqueContinents) {
                        var dataObj = uniqueContinents[continentKey];
                        dataObj.post_count = dataObj.post_count + 1;
                    } else {
                        uniqueContinents[continentKey] = {post_count: 1, display_name: pageData.continent, url_path: continentKey, type: "continent"};
                    }
             
                });

                //  for (const keyifiedContinent in uniqueContinents) { // update detailed count for each continent  
                //     that.$db.collection('continents_test').doc(keyifiedContinent).set({post_count: uniqueContinents[keyifiedContinent].count},  { merge: true });
                // }

                console.log("countries list: ");
                console.log(uniqueContinents);

                if (Object.keys(uniqueContinents).length > 0) {
                    console.log("yup");
                    for (const keyified in uniqueContinents) {
                        that.$db.collection('continents').doc(keyified).set(uniqueContinents[keyified],  { merge: true });
                    }
                }
            });
        },
      
  
        
    },
    mounted() {
        var that = this;
        this.$db.collection("tags_unapproved").onSnapshot(function(querySnapshot) {
            var result = [];
            querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                var stuff = doc.data();
                stuff['id'] = doc.id;
                
                result.push(stuff);
                // console.log(doc.id, " => ", doc.data());
            });
            that.tagsToApprove = result;
        });
      
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 
</style>






// WEBPACK FOOTER //
// src/components/AdminSitemap.vue